<template>
  <b-modal
    :visible="value"
    scrollable
    hide-footer
    centered
    size="lg"
    body-class="pb-2"
    :title="$t('subscription.upgrade')"
    dialog-class="upgrade-modal"
    @change="handleClose"
  >
    <fetching-data-spinner
      :loading="loadingPackages"
      :error="loadingPackagesError"
    />
    <upgrade-plans-view
      v-show="!purchaseVisible && !loadingPackages && !loadingPackagesError"
      :feature="feature"
      :feature-slug="featureSlug"
      :limit="limit"
      @select="handleSelect"
    />
    <purchase-wizard
      v-if="purchaseVisible"
      :plan-id="planId"
      :cycle="cycle"
      :skip-button-title="$t('forms.prev')"
      upgrade
      source="upgrade"
      @skip="purchaseVisible = false"
      @complete="handleUpgradeComplete"
    />
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import PurchaseWizard from '@/views/admin/purchase/PurchaseWizard'
import UpgradePlansView from '@/views/admin/purchase/components/UpgradePlansView'
import FetchingDataSpinner from '@/@okmenu/components/utils/FetchingDataSpinner'

export default {
  name: 'UpgradeModal',
  components: {
    FetchingDataSpinner, UpgradePlansView, PurchaseWizard, BModal,
  },
  props: {
    value: {
      type: Boolean,
    },
    limit: {
      type: [Number, String],
      default: 1,
    },
    feature: {
      type: String,
      default: '',
    },
    featureSlug: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      purchaseVisible: false,
      planId: null,
      cycle: 'yearly',
      loadingPackages: false,
      loadingPackagesError: false,
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.loadPlans()
      }
    },
  },
  mounted() {
    if (this.value) {
      this.loadPlans()
    }
  },
  methods: {
    handleClose(visible = false) {
      this.$emit('input', visible)
      this.purchaseVisible = false
    },
    loadPlans() {
      this.loadingPackages = true
      this.loadingPackagesError = null

      this.$store.dispatch('pricing/FETCH_PRICING')
        .catch(error => { this.loadingPackagesError = error })
        .finally(() => { this.loadingPackages = false })
    },
    handleSelect({ cycle, planId }) {
      this.cycle = cycle
      this.planId = planId
      this.purchaseVisible = true
    },
    handleUpgradeComplete() {
      this.$emit('input', false)
      this.purchaseVisible = false
    },
  },
}
</script>

<style lang="scss">
.upgrade-modal {
  .setup-wizard {
    margin-top: 0!important;
  }

  .modal-body {
    max-height: 80vh;
  }

  @media (min-width: 992px) {
    max-width: 808px;
  }
}
</style>
